/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// src/pages/AuthCallback.js

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handleRedirect() {
      try {
        const resp = await msal.handleRedirectPromise();

        if (resp) {
          const account = resp.account;
          msal.setActiveAccount(account);

          // Jump to your secured landing page
          navigate("/review-suppliers");
          return;
        }

        // If we reach here, nothing to process
        navigate("/");
      } catch (error) {
        console.error("Redirect handling error", error);
        navigate("/");
      }
    }

    handleRedirect();
  }, [navigate]);

  return <p>Completing login…</p>;
}